import { Variants } from "motion/react";

/**
 * Stagger container for sequential child animations
 * Use as parent container for elements that should animate in sequence
 */
export const staggerContainer: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.1,
    },
  },
};

/**
 * Fade in from below with spring animation
 * Default animation for most content elements
 */
export const fadeInUp: Variants = {
  hidden: {
    opacity: 0,
    y: 40,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      type: "spring",
      stiffness: 100,
      damping: 15,
      duration: 0.6,
    },
  },
};

/**
 * Fade in from right with spring animation
 * Used for dashboard preview image
 */
export const fadeInRight: Variants = {
  hidden: {
    opacity: 0,
    x: 60,
    scale: 0.95,
  },
  visible: {
    opacity: 1,
    x: 0,
    scale: 1,
    transition: {
      type: "spring",
      stiffness: 80,
      damping: 20,
      delay: 0.3,
    },
  },
};

/**
 * Scale in animation for images
 */
export const scaleIn: Variants = {
  hidden: {
    opacity: 0,
    scale: 0.9,
  },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      type: "spring",
      stiffness: 100,
      damping: 15,
    },
  },
};

/**
 * Card hover animation preset
 * Apply to motion.div with initial="rest" whileHover="hover"
 */
export const cardHover: Variants = {
  rest: {
    y: 0,
    scale: 1,
    boxShadow: "0 20px 60px rgba(0, 0, 0, 0.15)",
  },
  hover: {
    y: -8,
    scale: 1.02,
    boxShadow: "0 30px 80px rgba(0, 0, 0, 0.2)",
    transition: {
      type: "spring",
      stiffness: 300,
      damping: 20,
    },
  },
};

/**
 * Button animation props
 * Spread these onto motion.button or Button component
 */
export const buttonAnimation = {
  whileHover: { scale: 1.05 },
  whileTap: { scale: 0.95 },
  transition: { type: "spring", stiffness: 400, damping: 17 },
};

/**
 * Lazy image animation variants
 */
export const imageLoadAnimation: Variants = {
  loading: { opacity: 0 },
  loaded: { opacity: 1, scale: 1 },
};
